import { useMutation, useQueryClient } from '@tanstack/react-query';

import BackendService from '../services/backendService';
import { useMetrics } from './useMetrics';
import useRouterMatch from './useRouterMatch';

export const useUploadGoogleDrive = (activeTenantId: string) => {
  const client = useQueryClient();
  const metrics = useMetrics();
  const { templateId } = useRouterMatch();
  const { mutate: upload, isError, isLoading, isSuccess, reset, data } = useMutation(
    async ({ fileId }: { fileId: string; onSuccessFunction?: () => void }) => {
      const {
        filePath,
        fileType,
      } = await BackendService.instance.integrations.googleDrive.copyFileToBucket(
        fileId,
        activeTenantId,
      );
      return { filePath, fileType };
    },
    {
      onSuccess: (data, { onSuccessFunction }) => {
        if (onSuccessFunction) {
          onSuccessFunction();
        }
        const templateCacheKey = ['template', templateId];
        client.invalidateQueries(templateCacheKey);
        metrics.logEvent('Creator.Upload.GoogleDrive.Generator.Success', { templateId });
      },
    },
  );

  return {
    upload,
    isUploading: isLoading,
    isSuccess: isSuccess,
    isError,
    fileInfo: data,
    reset,
  };
};
